module.exports = RootreeVendor.ReactDOMClient;